import React, { useState } from "react"
import emailjs from "emailjs-com"
import { Helmet } from "react-helmet"

import Layout from "../components/layout"

function ContactUs() {
  // Email JS Constants
  const user_id = "user_HKWm8IjxeG7NHEdvOTFf9",
    service_id = "service_d3s7kiq",
    template_id = "template_l1b69ui"

  // Form values
  const [client_name, set_client_name] = useState(""),
    [client_email, set_client_email] = useState(""),
    [client_message, set_client_message] = useState(""),
    DEFAULT_SUBMIT_BUTTON_TEXT = "Send Message",
    DEFAULT_SUBMIT_BUTTON_SENDING_TEXT = "Sending...",
    [submit_button_text, set_submit_button_text] = useState(
      DEFAULT_SUBMIT_BUTTON_TEXT
    )

  function send_email(e) {
    e.preventDefault()

    set_submit_button_text(DEFAULT_SUBMIT_BUTTON_SENDING_TEXT)

    const params = {
      client_name,
      client_email,
      client_message,
    }

    emailjs.send(service_id, template_id, params, user_id).then(
      result => {
        set_submit_button_text(DEFAULT_SUBMIT_BUTTON_TEXT)
      },
      error => {
        alert(error.text)
      }
    )
  }

  return (
    <Layout>
      <Helmet>
        <title>InTouch Counselling Services - Contact Us</title>
      </Helmet>

      <div id="contact_us_wrapper">
        <section id="wrapper">
          <section id="one" className="wrapper  style2  style2_half">
            <div className="inner"></div>
          </section>
        </section>

        <section id="footer">
          <div className="inner">
            <h2 className="major">Get InTouch</h2>
            <p>
              I am available to meet and connect with you as soon as possible.
              Please feel free to contact me via-email, phone, or, by filling
              out the form below.
            </p>
            <form id="client_contact">
              <div className="fields">
                <div className="field">
                  <label htmlFor="client_name">Name</label>
                  <input
                    type="text"
                    name="client_name"
                    id="client_name"
                    onChange={event => set_client_name(event.target.value)}
                  />
                </div>
                <div className="field">
                  <label htmlFor="client_email">Email</label>
                  <input
                    type="email"
                    name="client_email"
                    id="client_email"
                    onChange={event => set_client_email(event.target.value)}
                  />
                </div>
                <div className="field">
                  <label htmlFor="client_message">Message</label>
                  <textarea
                    name="client_message"
                    id="client_message"
                    rows="4"
                    onChange={event => set_client_message(event.target.value)}
                  ></textarea>
                </div>
              </div>
              <ul className="actions">
                <li>
                  <input
                    id="send_email_btn"
                    type="submit"
                    value={submit_button_text}
                    onClick={send_email}
                  />
                </li>
              </ul>
            </form>
            <ul className="contact">
              <li className="icon solid fa-home">
                200 Matheson Blvd W. Suite 104 <br />
                Mississauga, Ontario <br />
                L5R-3L7 -{" "}
                <a
                  href="https://g.page/mississauga-physio?share"
                  target="_blank"
                  rel="noreferrer"
                  className="viewmap"
                >
                  View map
                </a>
              </li>
              <li className="icon solid fa-phone">
                <a href="tel:14162622900">416-262-2900</a>
              </li>
              <li className="icon solid fa-envelope">
                <a href="mailto:info@intouchcare.ca">info@intouchcare.ca</a>
              </li>
              <li className="icon brands fa-facebook-f">
                <a href="https://facebook.com/InTouchCareCounselling">
                  facebook.com/InTouchCareCounselling
                </a>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </Layout>
  )
}

export default ContactUs
